<ol class="list-group rounded-0">
    <li class="list-group-item d-flex justify-content-between mt-1 border bg-color-primary"
        *ngFor="let noti of notificationService.notifications; let idx = index;">
        <div class="ms-2 me-auto align-self-center">
            <div class="fw-bold">{{noti.title}}</div>
            <div>{{noti.description}}</div>
        </div>
    </li>
</ol>
<div class="maintenance">
    <div class="maintenance_contain">
        <!-- <img src="https://demo.wpbeaveraddons.com/wp-content/uploads/2018/02/main-vector.png" alt="maintenance"> -->
        <span class="pp-infobox-title-prefix">We're Making Improvements!</span>
        <div class="pp-infobox-title-wrapper">
            <h3 class="pp-infobox-title my-4">The website under maintenance!</h3>
        </div>
        <div class="pp-infobox-description">
            <p>Our site is currently down for scheduled maintenance. 
                We'll be back online shortly to serve you better.</p>
        </div>
    </div>
</div>